module.exports = __webpack_public_path__ + "static/img/avert.b25af781.png";